import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import AddressModal from './AddressModal';
import TestimoinalModal from './TestimoinalModal';
import InfoModal from './InfoModal';
import GiftInfoModal from './GiftInfoModal';
import RewardCardStatsModal from './RewardCardStatsModal';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';



const OrderStatus = {
    0: "Pending",
    1: "Processing",
    2: "Shipping",
    3: "Delivered",
    4: "Cancelled"
};

const OrderStatusColors = {
    0: '#3498db',  // Blue for Pending
    1: '#f39c12',  // Orange for Processing
    2: '#2ecc71',  // Green for Shipping
    3: '#9b59b6',  // Purple for Delivered
    4: '#e74c3c'   // Red for Cancelled
};



const UserDashboard = (props) => {

    const location = useLocation();
    const authData = useSelector(state => state.authState);
   
    const [show, setShow] = useState(false);
    const [orderList, setOrderList] = useState([]);
    const [rewardCardList, setRewardCardList] = useState([]);
    const [orderPendingList, setOrderPendingList] = useState([]);
    const [userDetail, setUserDetail] = useState({});
    const [editMode, setEditMode] = useState(false);
    const handleEditModeToggle = () => {
        setEditMode(!editMode);
    };
    const navigate = useNavigate();
    const [userMultipleAddress, setUserMultipleAddress] = useState([])
    const [userMultipleTestimonial, setUserMultipleTestimonial] = useState([])
    const [isAddingAddress, setIsAddingAddress] = useState(false);
    const initialNewAddress = {
        id: 0,
        userId: authData.user_id,
        m_form_name: '',
        m_address: '',
        m_city: '',
        m_pin_code: '',
        m_country: '',
        m_address_type: ''
    }
    const initialNewTestimonial = {
        id: 0,
        m_form_name: '',
        userId: authData.user_id,
        client_feedback: ''
    }

    const dispatch = useDispatch();
    const [newAddressData, setNewAddressData] = useState(initialNewAddress);
    const [newTestimonialData, setNewTestimonialData] = useState(initialNewTestimonial);
    const [editAddressMode, setEditAddressMode] = useState(false)

    const [isAddingTestimonial, setIsAddingTestimonial] = useState(false)
    const [editTestimonialMode, setEditTestimonialMode] = useState(false)

    const [active, setActive] = useState(false)

    const [clientTable, setClientTable] = useState([]);
    const [stagesList, setStagesList] = useState([]);
    const [levelList, setLevelList] = useState([]);

    const [isViewInfo, setIsViewInfo] = useState(false);

    const [contributorInfo, setContributorInfo] = useState({});


    const handleStageClick = (stage) => {
        // Find the tab you want to activate
        const tab2 = new window.bootstrap.Tab(document.getElementById('pills-security-tab'));
        // Activate Tab 2]
        if (tab2) {
            tab2.show();
            getLevelList(stage);

        }
    };
    const handleLevelClick = (level) => {
        debugger;
        console.log(level)
        // Find the tab you want to activate
        const tab2 = new window.bootstrap.Tab(document.getElementById('pills-card-tab'));
        // Activate Tab 2]
        if (tab2) {
            tab2.show();
            getRewardCardList(level);

        }
    };

    const showMenuFx = () => {
        if (show === true) {
            setShow(false);
        } else {
            setShow(true);
        }
    }


    const getClientData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/ClientMaster/allclient?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                alert(response.response?.data?.errors)
            }

            if (response.status === true) {
                console.log(response)
                setClientTable(response.clientMasterData)
                // setTotalPage(response.totalPages)
                // alert(response.message);
            }
            else {
                alert(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    };



    const onChangeHandle = (e) => {
        //console.log("run the function for chnag the valeie")
        const { name, value, type } = e.target;

        setUserDetail((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const getStagesList = async () => {

        try {
            const response = await apiService.get(`/api/Stage_Details_Master/GetStage_Details_Master`)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            console.log(response)

            if (response.status === true) {
                setStagesList(response.data);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    const getLevelList = async (stage) => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/Lv_Details_Master/Get_Lv_Stage_Wise?stageId=${stage}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            console.log(response, "level")

            if (response.status === true) {
                setLevelList(response.data);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    const getRewardCardList = async (level) => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/TreeTesting/GetUserRewadCards?userMob=${userDetail.user_mobile}&level=${level}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            console.log(response)

            if (response.status === true) {
                setRewardCardList(response.rewardCardDataList);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    const getOrderList = async () => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/OrderMaster/orderDetailByUserId?userId=${authData.user_id}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                setOrderList(response.orderMasterData)
                setOrderPendingList(response.orderMasterPendingData)
            }
            else {
                if (response.message === "Invalid Token") {
                    navigate("/Login");
                    dispatch(resetToken());
                    dispatch(allRemoveItem());
                }
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    const getUserDetail = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/admin/User_Detail/GetUserById?Id=${authData.user_id}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                setUserDetail(response.user_Detail)
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }


    const [erroruserDetail, setErroruserDetail] = useState({})

    const validationUserDetail = () => {

        const errors = {};

        if (!userDetail.user_name) {
            errors.user_name = "Name is required";
        }

        if (!userDetail.user_mobile) {
            errors.user_mobile = "Mobile is required";
        } else if (!/^\d{10}$/.test(userDetail.user_mobile)) {
            errors.user_mobile = "Mobile number must be 10 digits";
        }

        setErroruserDetail(errors);

        // Return true if there are no errors
        return Object.keys(errors).length === 0;
    }

    const UpdateUserDetail = async () => {

        let validation = await validationUserDetail()
        if (!validation) {
            return
        }

        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.post(`/api/admin/User_Detail/Edit_User`, userDetail, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                // setUserDetail(response.user_Detail)
                setEditMode(false);
                // setEditMode(false)
            }
            else {
                setEditMode(false);
                console.log("update successfully");
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    }

    const getUserMultipleAddress = async () => {
        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                    'User_id': newAddressData.userId
                }
            };

            const response = await apiService.get(`/api/admin/User_Detail/GetUserMultiAddress`, config)

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                // console.log(response.multiUserAddData)

                setUserMultipleAddress(response.multiUserAddData)
            }
            else {
                // console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    }

    const getUserMultipleTestimonial = async () => {
        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                    'User_id': newTestimonialData.userId
                }
            };

            const response = await apiService.get(`/api/ClientMaster/userWiseTestimonials`, config)

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                // console.log(response.multiUserAddData)

                setUserMultipleTestimonial(response.clientMasterData)
            }
            else {
                // console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    }

   

    useEffect(() => {
        
    GetLoginSession();

        if (authData.login) {
            getOrderList()
            getUserDetail()
            getUserMultipleAddress()
            getUserMultipleTestimonial()
            getStagesList();
            //getRewardCardList()
        }else{
            navigate("/login");
            
        dispatch(resetToken());
        //dispatch(allRemoveItem());
        }
    }, [])


  

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewAddressData(prevData => ({
            ...prevData,
            [name]: value
        }));
        setNewTestimonialData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const [errorAddressData, setErrorAddressData] = useState({});
    const [errorTestimonialData, setErrorTestimonialData] = useState({});

    const validateForm = () => {
        const errors = {};

        if (!newAddressData.m_form_name) {
            errors.m_form_name = "Name is required";
        }

        if (!newAddressData.m_address) {
            errors.m_address = "Address is required";
        }

        if (!newAddressData.m_city) {
            errors.m_city = "City is required";
        }

        if (!newAddressData.m_pin_code) {
            errors.m_pin_code = "Pin code is required";
        }

        if (!newAddressData.m_country) {
            errors.m_country = "Country is required";
        }

        if (!newAddressData.m_address_type) {
            errors.m_address_type = "Address type is required";
        }

        setErrorAddressData(errors)
        return Object.keys(errors).length === 0;
    };


    const handleAddAddress = async () => {

        let validate = await validateForm()
        if (!validate) {
            return
        }

        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };
            const response = await apiService.post(`/api/admin/User_Detail/AddMultiAddress`, newAddressData, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                console.log("Add New Address");
                setNewAddressData(initialNewAddress)
                getUserMultipleAddress()
                setEditAddressMode(false)
            }
            else {
                console.log(response);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    };

    const handleAddTestimonial = async () => {

        // let validate = await validateForm()
        // if (!validate) {
        //     return
        // }
        console.log(newTestimonialData)

        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };
            const response = await apiService.post(`/api/ClientMaster/create`, newTestimonialData, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                console.log("Add New Testimonial");
                setNewTestimonialData(initialNewTestimonial)
                getUserMultipleTestimonial()
                setEditTestimonialMode(false)
            }
            else {
                console.log(response);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    };

    const handleUpdateAddAddress = async () => {


        let validate = await validateForm()
        if (!validate) {
            return
        }
        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.put(`/api/admin/User_Detail/UpdateUserMultiAdd?id=${newAddressData.id}`, newAddressData, config)

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                console.log(response.message);
                setNewAddressData(initialNewAddress)
                setEditAddressMode(false)
                getUserMultipleAddress()
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    };

    const handleUpdateAddTestimonial = async () => {


        // let validate = await validateForm()
        // if (!validate) {
        //     return
        // }
        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.put(`/api/ClientMaster/update?clientId=${newTestimonialData.id}`, newTestimonialData, config)

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                console.log(response.message);
                setNewTestimonialData(initialNewTestimonial)
                setEditTestimonialMode(false)
                getUserMultipleTestimonial()
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    };

    const onHanldeNewTestimonial = () => {
        setEditTestimonialMode(true)
        setIsAddingTestimonial(true)
    }

   
    const onHanldeLevelInfo = (data) => {
        setIsViewInfo(true);
        setContributorInfo(data);
        //document.body.classList.add("modal-open-blur");
    }

    
    const handleInfoClose = () => {
        setIsViewInfo(false);
        //document.body.classList.remove("modal-open-blur");
    }

    const onHanldeNewAddress = () => {
        setEditAddressMode(true)
        setIsAddingAddress(true)
    }

    const onHandleUpdateAddress = (id) => {
        let findArray = userMultipleAddress.find((data) => data.id === id)
        setNewAddressData(findArray)
        setEditAddressMode(true)
        setIsAddingAddress(false)
    }

    const onHandleUpdateTestimonial = (id) => {
        let findArray = userMultipleTestimonial.find((data) => data.id === id)
        console.log(findArray)
        setNewTestimonialData(findArray);
        setEditTestimonialMode(true)
        setIsAddingTestimonial(false)
    }

    const handleEditConfirm = () => {
        setEditAddressMode(false);
        setNewAddressData(initialNewAddress)
        setErrorAddressData({})

        setEditTestimonialMode(false);
        setNewTestimonialData(initialNewTestimonial)
        setErrorTestimonialData({})
    };

    const onHandleDeleteAddress = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this address?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/admin/User_Detail/DeletUserMulAdd?id=${id}`, config)
                if (response.response && response.response.data.errors) {
                    console.log(response.response?.data?.errors)
                }

                if (response.status === true) {
                    console.log(response.message);
                    getUserMultipleAddress()
                }
                else {
                    alert(response.message);
                }
            } catch (error) {
                console.log(error)
                alert('SomeThing went wrong!!');
            }
        } else {
            console.log('Deletion canceled.');
        }
    };

    const onHandleDeleteTestimonial = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this Testimonial?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/ClientMaster/delete?clientId=${id}`, config)
                if (response.response && response.response.data.errors) {
                    console.log(response.response?.data?.errors)
                }

                if (response.status === true) {
                    console.log(response.message);
                    getUserMultipleTestimonial()
                }
                else {
                    alert(response.message);
                }
            } catch (error) {
                console.log(error)
                alert('SomeThing went wrong!!');
            }
        } else {
            console.log('Deletion canceled.');
        }
    };

    
    const GetLoginSession = async () => {
        try {
    
    
          const response = await apiService.get(`api/admin/User_Detail/LoginSession`);
        
          if (response.response && response.response.data.errors) {
            console.log(response);
            //alert(response.response?.data?.errors);
            return false;
          }
    
          if (response.status === true) {
            return true;
          }
          else {
            dispatch(resetToken());
            navigate("/Login");
          }
        } catch (error) {
          //console.log(error, "errorerror")
          alert('SomeThing went wrong!!');
          return false;
        }
      }
    
    
    useEffect(() => {
        const option = new URLSearchParams(location.search).get('option');
        if (option) {
            setActive(option)
        }
        // Cleanup effect if the component is unmounted while modal is open
        // return () => {
        //     document.body.classList.remove("modal-open-blur");
        //   };
    })

    const goToLink = async () => {
        try {
    
          const response = await apiService.get(`/api/PointSys/GetRewardSysToken`)
          if (response.response && response.response.data.errors) {
            alert(response.response?.data?.errors)
          }
          
          console.log(response);
    
          if (response.status === true) {
            const tokenData = encodeURIComponent(response.tokenData);
            const tokenId = encodeURIComponent(response.tokenId);
            console.log(process.env.REACT_APP_POINTS_URL)
            const link = `${process.env.REACT_APP_POINTS_URL}/authenticate?tokenData=${tokenData}&tokenId=${tokenId}`
            window.open(link, '_blank');
            
          }
          else {
            alert(response.message);
            console.log(response)
          }
        } catch (error) {
          console.log(error)
          alert('SomeThing went wrong!!');
        }
      }
    
     
    return (
        <>
            {/* Breadcrumb Section Start */}
            <section className="breadscrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadscrumb-contain">
                                <h2>User Profile</h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <a href="index-2.html">
                                                <i className="fa-solid fa-house" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            User Profile
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Breadcrumb Section End */}
            {/* User Dashboard Section Start */}

            <section className="user-dashboard-section section-b-space">
                <div className="container-fluid-lg">
                    <div className="row">

                        <div className="col-xxl-12 col-lg-12">

                            <div className="dashboard-right-sidebar">
                                <div className="tab-content" id="pills-tabContent">
                                    <div
                                        // className="tab-pane fade show active"

                                        className={!active ? "tab-pane fade show active" : "tab-pane fade show"}
                                        id="pills-dashboard"
                                        role="tabpanel"
                                        aria-labelledby="pills-dashboard-tab"
                                    >
                                        <div className="dashboard-home mb-0">
                                            <div className="title mb-0">
                                                <h2>Hi {userDetail.user_name}</h2>
                                                <h6 className="text-content mt-2">
                                                    +91-{userDetail.user_mobile}
                                                </h6>
                                                <span className="title-leaf">
                                                    <svg className="icon-width bg-gray">
                                                        <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="total-box">
                                                <div className="row g-sm-4 g-3">
                                                    <div className="col-xxl-12 col-lg-6 col-md-4 col-sm-6">
                                                        <NavLink className="text-dark" to="/my-orders" >
                                                        <div className="totle-contain shadow">
                                                            <img
                                                                src="../assets/images/svg/pending.svg"
                                                                className="img-1  lazyload"
                                                                alt=""
                                                            />
                                                            <img
                                                                src="../assets/images/svg/pending.svg"
                                                                className=" lazyload"
                                                                alt=""
                                                            />
                                                            <div className="totle-detail">
                                                                <h3>My Orders</h3>
                                                                <h6>Completed : {orderList.length ? orderList.length : 0} | Pending : 0</h6>
                                                            </div>
                                                        </div>
                                                        </NavLink>
                                                        
                                                    </div>

                                                    {/* <div className="col-xxl-4 col-lg-6 col-md-4 col-sm-6">
                                                        <div className="totle-contain">
                                                            <img
                                                                src="../assets/images/svg/wishlist.svg"
                                                                className="img-1  lazyload"
                                                                alt=""
                                                            />
                                                            <img
                                                                src="../assets/images/svg/wishlist.svg"
                                                                className=" lazyload"
                                                                alt=""
                                                            />
                                                            <div className="totle-detail">
                                                                <h5>Total Wishlist</h5>
                                                                <h3>32158</h3>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            {/* <div className="dashboard-title">
                                                <h3>Account Information</h3>
                                            </div> */}
                                             <div className="row g-4">
                                             {/*   <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                    <div className="seller-grid-box seller-grid-box-1 shadow mb-0">
                                                        <div className="contain-name">
                                                            <div>
                                                                <h3 className='mb-2'>Earn with Valorelle
                                                                </h3>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} onClick={goToLink}>
                                                                        <i className="fa fa-trophy mt-1" />See Valorelle Rewards <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/gifts">
                                                                        <i className="fa fa-gift mt-1" /> Exciting Gifts <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/all-stages">
                                                                    <i class="fa-solid fa-bars-progress mt-1"/> See your Progress <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/my-earnings">
                                                                    <i class="fa fa-coins mt-1"/> My Earnings <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div> 
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/">
                                                                        <i className="fa fa-info-circle mt-1" /> Learn more about the Reward system <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>*/}

                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                    <div className="seller-grid-box seller-grid-box-1 shadow mb-0">
                                                        <div className="contain-name">
                                                            <div>
                                                                <h3 className='mb-2'>Account Settings
                                                                </h3>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/saved-addresses">
                                                                        <i className="fa fa-map-marker mt-1" /> Saved Addresses <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/my-profile">
                                                                        <i className="far fa-address-book mt-1" /> Edit Profile <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/my-bank-details">
                                                                    <i class="fa fa-university mt-1"/> My Bank Details <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/my-cards-wallets">
                                                                    <i class="fa fa-wallet mt-1"/> My Cards and Wallet <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                    <div className="seller-grid-box seller-grid-box-1 shadow mb-0">
                                                        <div className="contain-name">
                                                            <div>
                                                                <h3 className='mb-2'>My Activity
                                                                </h3>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/">
                                                                        <i className="fa fa-edit mt-1" /> Reviews <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>
                                                                <div className='mb-2'>
                                                                    <NavLink style={{fontSize:"medium"}} to="/">
                                                                        <i className="far fa-comments mt-1" /> Question & Answers <i className="fa fa-arrow-right float-end mt-1" />
                                                                    </NavLink>
                                                                </div>                                                               
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <button className="btn theme-bg-color text-white btn-md w-100 mt-4 fw-bold"><i className="fa-solid fa-arrow-left icon" /> Return to shopping</button>
                                                <button className='btn btn-md bg-danger cart-button text-white w-100 mb-2'> Logout   <i className="ml-2 fa fa-sign-out" /> </button>

                                                        
                                            </div>
                                        </div>
                                    </div>
                                 
                                    <div
                                        className="tab-pane fade show"
                                        id="pills-order"
                                        role="tabpanel"
                                        aria-labelledby="pills-order-tab"
                                    >
                                       
                                    </div>

                                    {/* Address */}
                                    <div
                                        // className="tab-pane fade show"
                                        className={active ? "tab-pane fade show active" : "tab-pane fade show"}

                                        id="pills-address"
                                        role="tabpanel"
                                        aria-labelledby="pills-address-tab"
                                    >
                                        <div className="dashboard-address">
                                            <div className="title title-flex">
                                                <div>
                                                    <h2>My Address Book</h2>
                                                    <span className="title-leaf">
                                                        <svg className="icon-width bg-gray">
                                                            <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <button
                                                    className="btn theme-bg-color text-white btn-sm fw-bold mt-lg-0 mt-3"
                                                    onClick={() => { onHanldeNewAddress() }}
                                                >
                                                    <i data-feather="plus" className="me-2" /> Add New Address
                                                </button>
                                            </div>

                                            <div className="row g-sm-4 g-3">

                                                {userMultipleAddress.length != 0 ?
                                                    <>
                                                        {userMultipleAddress.map((key, index) => (
                                                            <>
                                                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-6">
                                                                    <div className="address-box">
                                                                        <div>
                                                                            <div className="form-check">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="jack"
                                                                                    id={`flexRadioDefault${index}`}
                                                                                    defaultChecked=""
                                                                                />
                                                                            </div>
                                                                            <div className="label">
                                                                                <label>{key.m_address_type}</label>
                                                                            </div>

                                                                            <div className="table-responsive address-table">
                                                                                <table className="table">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td colSpan={2}>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_form_name}
                                                                                                    id={`m_form_name_${index}`}
                                                                                                    name={`m_form_name_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Address :</td>
                                                                                            <td>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_address}
                                                                                                    id={`m_address_${index}`}
                                                                                                    name={`m_address_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Pin Code :</td>
                                                                                            <td>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_pin_code}
                                                                                                    id={`m_pin_code_${index}`}
                                                                                                    name={`m_pin_code_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>City:</td>
                                                                                            <td>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_city}
                                                                                                    id={`m_city_${index}`}
                                                                                                    name={`m_city_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Country :</td>
                                                                                            <td>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_country}
                                                                                                    id={`m_country_${index}`}
                                                                                                    name={`m_country_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                        <div className="button-group">
                                                                            <button
                                                                                className="btn btn-sm add-button w-100"
                                                                                onClick={() => onHandleUpdateAddress(key.id)}
                                                                            >
                                                                                {/* <i data-feather="edit" /> */}
                                                                                Edit
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm add-button w-100"
                                                                                onClick={() => onHandleDeleteAddress(key.id)}
                                                                            >
                                                                                {/* <i data-feather="trash-2" /> */}
                                                                                Remove
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ))}
                                                    </>
                                                    :
                                                    <>
                                                        <h3 style={{ display: "flex", justifyContent: "center", fontSize: 28, fontWeight: "bold" }}>Please add your address for further order</h3>
                                                    </>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    {/* testimonial */}
                                    <div
                                        className="tab-pane fade show"
                                        //className={active ? "tab-pane fade show active" : "tab-pane fade show"}

                                        id="pills-testimonial"
                                        role="tabpanel"
                                        aria-labelledby="pills-testimonial-tab"
                                    >
                                        <div className="dashboard-address">
                                            <div className="title title-flex">
                                                <div>
                                                    <h2>My Testimonials</h2>
                                                    <span className="title-leaf">
                                                        <svg className="icon-width bg-gray">
                                                            <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <button
                                                    className="btn theme-bg-color text-white btn-sm fw-bold mt-lg-0 mt-3"
                                                    onClick={() => { onHanldeNewTestimonial() }}
                                                >
                                                    <i data-feather="plus" className="me-2" /> Add New Testimonial
                                                </button>
                                            </div>

                                            <div className="row g-sm-4 g-3">

                                                {userMultipleTestimonial.length != 0 ?
                                                    <>
                                                        {userMultipleTestimonial.map((key, index) => (
                                                            <>
                                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12">

                                                                    <div className="address-box">
                                                                        <h5>Your testimonial no . {index + 1}</h5>

                                                                        <div>

                                                                            <div className="table-responsive address-table mt-3">
                                                                                <table className="table">
                                                                                    <tbody>

                                                                                        <thead>
                                                                                            <th>
                                                                                                <td className='mt-3'>Your feddback :</td>
                                                                                            </th>
                                                                                        </thead>

                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td >
                                                                                                    <input type='text'
                                                                                                        disabled={!editMode}
                                                                                                        style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "tdansparent", width: "100vh" }}
                                                                                                        value={key.client_feedback}
                                                                                                        id={`client_feedback_${index}`}
                                                                                                        name={`client_feedback_${index}`}
                                                                                                        onChange={onChangeHandle}
                                                                                                    />
                                                                                                </td>

                                                                                            </tr>

                                                                                        </tbody>



                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                        <div className="button-group">
                                                                            <button
                                                                                className="btn btn-sm add-button"
                                                                                onClick={() => onHandleUpdateTestimonial(key.id)}
                                                                            >
                                                                                {/* <i data-feather="edit" /> */}
                                                                                Edit
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm add-button"
                                                                                onClick={() => onHandleDeleteTestimonial(key.id)}
                                                                            >
                                                                                {/* <i data-feather="trash-2" /> */}
                                                                                Remove
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ))}
                                                    </>
                                                    :
                                                    <>
                                                        <h3 style={{ display: "flex", justifyContent: "center", fontSize: 28, fontWeight: "bold" }}>Please add your address for further order</h3>
                                                    </>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    {/* Stages */}
                                    <div
                                        className="tab-pane fade show"
                                        id="pills-stages"
                                        role="tabpanel"
                                        aria-labelledby="pills-stages-tab"
                                    >
                                        <div className="title">
                                            <h2>All Grades</h2>
                                            <span className="title-leaf">
                                                <svg className="icon-width bg-gray">
                                                    <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                </svg>
                                            </span>
                                        </div>
                                        {stagesList.map((item) => {
                                            return (
                                                <>
                                                    <div onClick={() => { handleStageClick(item.id) }} className="seller-grid-box seller-grid-box-1 shadow-lg mb-2">
                                                        <div className="grid-image mb-0">
                                                            <div className="contain-name">
                                                                <div>

                                                                    <h3 className="mr-3">{item.stage_no}. {item.stage_display_name}<label className="product-label float-end"> Total 15 Levels
                                                                    </label>
                                                                    </h3>
                                                                    <div className="since-number">
                                                                        <h5>{item.stage_short_desc}</h5>
                                                                    </div>
                                                                    <div className="since-number">
                                                                        <h6>{item.stage_desc}</h6>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="image float-end">
                                                                <img
                                                                    src="../assets/images/vendor-page/logo/6.png"
                                                                    className="img-fluid"
                                                                    alt=""
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                </>)
                                        })}



                                    </div>

                                    {/* levels */}
                                    <div
                                        className="tab-pane fade show"
                                        id="pills-security"
                                        role="tabpanel"
                                        aria-labelledby="pills-security-tab"
                                    >
                                        <div className="title">
                                            <h2>All Levels</h2>
                                            <span className="title-leaf">
                                                <svg className="icon-width bg-gray">
                                                    <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                </svg>
                                            </span>
                                        </div>
                                        {levelList.map((item) => {
                                            return (
                                                <>
                                                    <div onClick={() => { handleLevelClick(item.id) }} className={`seller-grid-box seller-grid-box-1 shadow-lg mb-2 ${item.lv_status === "open" ? "" : "bg-secondary"}`}>
                                                        <div className="grid-image mb-0">
                                                            <div className="contain-name">
                                                                <div>

                                                                    <h3 className="mr-3">{item.lv_name} <label className="product-label float-end"> 4 Reward Cards
                                                                    </label>
                                                                    </h3>
                                                                    <div className="since-number">
                                                                        <h5>{item.lv_short_desc}</h5>
                                                                    </div>
                                                                    <div className="since-number">
                                                                        <h6>{item.lv_desc}</h6>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="image float-end">
                                                                <img
                                                                    src="../assets/images/level/trophy-icon-color.png"
                                                                    className="img-fluid"
                                                                    alt=""
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                </>)
                                        })}

                                   

                                    </div>

                                    {/* rewards */}
                                    <div
                                        className="tab-pane fade show"
                                        id="pills-card"
                                        role="tabpanel"
                                        aria-labelledby="pills-card-tab"
                                    >
                                        <div className="dashboard-card">
                                            <div className="title title-flex">
                                                <div>
                                                    <h2>My Reward Details</h2>
                                                    <span className="title-leaf">
                                                        <svg className="icon-width bg-gray">
                                                            <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>


                                            <div className="row g-4">

                                                {rewardCardList.map((item) => {
                                                    return (
                                                        <>
                                                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                                <div className="seller-grid-box seller-grid-box-1 shadow-lg mb-0">
                                                                    <i className="fa fa-info-circle float-end" onClick={onHanldeLevelInfo.bind(this, item.pointContributorsList)}></i>

                                                                    <div className="grid-image">
                                                                        <div className="image">
                                                                            <img
                                                                                src="../assets/images/vendor-page/logo/2.png"
                                                                                className="img-fluid"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="contain-name">
                                                                            <div>
                                                                                <div className="since-number">
                                                                                    <h6>Reward Card no.</h6>
                                                                                </div>
                                                                                <h3>{item.reward_card_no}</h3>
                                                                            </div>
                                                                            <div class="progress mb-2">
                                                                                <div class="progress-bar" role="progressbar" style={{ width: `${item.level_progress_percent}%`, backgroundColor: "#0da487" }} aria-valuenow={item.level_progress_percent} aria-valuemin="0" aria-valuemax="100">{item.level_progress_percent}%</div>
                                                                            </div>
                                                                            <label className="product-label">{item.total_coins_earned} / 18000 Shiv Coins Earned</label>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </>)
                                                })}

                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                    <div className="seller-grid-box seller-grid-box-1 shadow-lg mb-0">
                                                        <i className="fa fa-info-circle float-end" onClick={onHanldeLevelInfo}></i>

                                                        <div className="grid-image">
                                                            <div className="image">
                                                                <img
                                                                    src="../assets/images/vendor-page/logo/2.png"
                                                                    className="img-fluid"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="contain-name">
                                                                <div>
                                                                    <div className="since-number">
                                                                        <h6>Reward Card no.</h6>
                                                                    </div>
                                                                    <h3>XXXXXXXXXXXXX</h3>
                                                                </div>
                                                                <div class="progress mb-2">
                                                                    <div class="progress-bar" role="progressbar" style={{ width: "100%", backgroundColor: "#0da487" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div>
                                                                </div>
                                                                <label className="product-label">18000 / 18000 Shiv Coins Earned</label>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                
                                                </div>

                                        </div>
                                    </div>


                                    {/* profile */}
                                    <div
                                        className="tab-pane fade show"
                                        id="pills-profile"
                                        role="tabpanel"
                                        aria-labelledby="pills-profile-tab"
                                    >
                                        <div className="dashboard-profile">
                                            <div className="title">
                                                <h2>My Profile</h2>
                                                <span className="title-leaf">
                                                    <svg className="icon-width bg-gray">
                                                        <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                    </svg>
                                                </span>
                                            </div>
                                            {/* <div className="profile-detail dashboard-bg-box">
                                                <div className="dashboard-title">
                                                    <h3>Profile Name</h3>
                                                </div>
                                                <div className="profile-name-detail">
                                                    <div className="d-sm-flex align-items-center d-block">
                                                        <h3>{userDetail.user_name}</h3>
                                                    </div>
                                                    <a
                                                        href="javascript:void(0)"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#editProfile"
                                                    >
                                                        Edit
                                                    </a>
                                                </div>
                                                {/* <div className="location-profile">
                                                    <ul>
                                                        <li>
                                                            <div className="location-box">
                                                                <i data-feather="map-pin" />
                                                                <h6>Downers Grove, IL</h6>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="location-box">
                                                                <i data-feather="mail" />
                                                                <h6>vicki.pope@gmail.com</h6>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="location-box">
                                                                <i data-feather="check-square" />
                                                                <h6>Licensed for 2 years</h6>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="profile-description">
                                                    <p>
                                                        Residences can be classified by and how they are
                                                        connected to neighbouring residences and land. Different
                                                        types of housing tenure can be used for the same
                                                        physical type.
                                                    </p>
                                                </div> */}
                                            {/* </div> */}
                                            <div className="profile-about dashboard-bg-box">
                                                <div className="row">
                                                    <div className="col-xxl-7">
                                                        {/* <div className="dashboard-title mb-3">
                                                            <h3>Profile About</h3>
                                                        </div> */}
                                                        <div className="table-responsive">
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Name :</td>
                                                                        <input
                                                                            type='text'
                                                                            disabled={!editMode}
                                                                            style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                            value={userDetail.user_name}
                                                                            id="user_name"
                                                                            name='user_name'
                                                                            onChange={onChangeHandle} // Corrected from onchange to onChange
                                                                        />
                                                                        {erroruserDetail.user_name && <div className="text-danger">{erroruserDetail.user_name}</div>}

                                                                        {/* <td>{userDetail.user_name}</td> */}
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <td>Gender :</td>
                                                                        <td>{userDetail.user_name}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Birthday :</td>
                                                                        <td>21/05/1997</td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <td>Phone Number :</td>
                                                                        <td>
                                                                            <a href="javascript:void(0)">
                                                                                {" "}
                                                                                <input type='text'
                                                                                    disabled={!editMode}
                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                    value={userDetail.user_mobile}
                                                                                    id="user_mobile"
                                                                                    name='user_mobile'
                                                                                    onChange={onChangeHandle}
                                                                                />
                                                                                {erroruserDetail.user_mobile && <div className="text-danger">{erroruserDetail.user_mobile}</div>}
                                                                                {/* {userDetail.user_mobile} */}
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <td>Address :</td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <td>Email :</td>
                                                                        <td>
                                                                            <a href="javascript:void(0)">
                                                                                <input type='text'
                                                                                    // disabled={!editMode}
                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                    value={userDetail.user_email}
                                                                                    id="user_email"
                                                                                    name='user_email'
                                                                                    onChange={onChangeHandle}
                                                                                    disabled={true}
                                                                                />
                                                                                {/* {userDetail.user_email} */}
                                                                                <span onClick={editMode ? UpdateUserDetail : handleEditModeToggle}>
                                                                                    {editMode ? 'Save' : 'Edit'}
                                                                                </span>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        {/* <div className="dashboard-title mb-3">
                                                            <h3>Login Details</h3>
                                                        </div> */}
                                                        {/* <div className="table-responsive">
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Email :</td>
                                                                        <td>
                                                                            <a href="javascript:void(0)">
                                                                                vicki.pope@gmail.com
                                                                                <span
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#editProfile"
                                                                                >
                                                                                    Edit
                                                                                </span>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Password :</td>
                                                                        <td>
                                                                            <a href="javascript:void(0)">
                                                                                ●●●●●●
                                                                                <span
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#editProfile"
                                                                                >
                                                                                    Edit
                                                                                </span>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div> */}
                                                    </div>
                                                    <div className="col-xxl-5">
                                                        <div className="profile-image">
                                                            <img
                                                                src="../assets/images/inner-page/dashboard-profile.png"
                                                                className="img-fluid  lazyload"
                                                                alt=""
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

          
            {isViewInfo &&
                <InfoModal
                    contributorInfo={contributorInfo}
                    handleInfoClose={handleInfoClose} />
            }

            {editAddressMode &&
                <AddressModal
                    handleInputChange={handleInputChange}
                    newAddressData={newAddressData}
                    handleEditConfirm={handleEditConfirm}
                    handleUpdateAddAddress={handleUpdateAddAddress}
                    isAddingAddress={isAddingAddress}
                    handleAddAddress={handleAddAddress}
                    errorAddressData={errorAddressData}
                />}

            {editTestimonialMode &&
                <TestimoinalModal
                    handleInputChange={handleInputChange}
                    newTestimonialData={newTestimonialData}
                    handleEditConfirm={handleEditConfirm}
                    handleUpdateAddTestimonial={handleUpdateAddTestimonial}
                    isAddingTestimonial={isAddingTestimonial}
                    handleAddTestimonial={handleAddTestimonial}
                    errorTestimonialData={errorTestimonialData}
                />}
            {/* 
            <div className={isAddingTestimonial||isAddingAddress||editAddressMode||editTestimonialMode?"bg-overlay show ":"bg-overlay"}></div> */}


        </>

    )
}

export default UserDashboard;